/* eslint-disable import/prefer-default-export */
export const Groups = {
  parameters: {
    label: 'פרמטרים'
  },
  'names-management': {
    label: 'ניהול שמות רכבים'
  }
};

/** @typedef { keyof typeof Groups } MenuGroupName */
